import styled from "@emotion/styled";
import { fontRoboto } from "@product/scmp-sdk";

import { ContentShareWidget } from "~/components/content/content-share-widget";

export const Container = styled.aside`
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: center;

  inline-size: min-content;
`;

export const SocialShareCount = styled.span`
  min-block-size: 18px;
  margin-block-end: 14px;

  color: #001246;
  font-weight: 700;
  font-size: 18px;
  font-family: ${fontRoboto};
  line-height: 18px;
`;

type Props = {
  $isColumn: boolean;
};

export const StyledContentShareWidget = styled(ContentShareWidget)<Props>`
  display: flex;
  flex-flow: ${props => (props.$isColumn ? "column" : "row")};
  gap: 16px;
  justify-content: flex-start;
  align-items: center;
`;
